// extracted by mini-css-extract-plugin
var _1 = "webpack-components-shared-StudiesTimedOutMessage-StudiesTimedOutMessage-module__Message";
var _2 = "webpack-components-shared-StudiesTimedOutMessage-StudiesTimedOutMessage-module__Wrapper";
export { _1 as "Message", _2 as "Wrapper" }
